import { render, staticRenderFns } from "./MRC_ESS_CardActions.vue?vue&type=template&id=0fd801f2&"
import script from "./MRC_ESS_CardActions.vue?vue&type=script&lang=js&"
export * from "./MRC_ESS_CardActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCardActions})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fd801f2')) {
      api.createRecord('0fd801f2', component.options)
    } else {
      api.reload('0fd801f2', component.options)
    }
    module.hot.accept("./MRC_ESS_CardActions.vue?vue&type=template&id=0fd801f2&", function () {
      api.rerender('0fd801f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MRC_ESS_CardActions.vue"
export default component.exports